import React from 'react';
import { ProgressGraph } from '../../../../components/dashboard/ProgressGraph';
import { CountUp } from '../../../../components/dashboard/CountUp';

export const OtherReport: React.FC = () => {
  const stats = {
    gamesPlayed: {
      total: 25,
      won: 18,
      lost: 5
    },
    questions: {
      correct: 98,
      incorrect: 22
    }
  };

  const months = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  const progressData = Array.from({ length: 12 }, (_, i) => ({
    month: i + 1,
    score: Math.round(65 + (Math.random() * 25))
  }));

  return (
    <div className="grid grid-cols-10 gap-8 mt-8">
      <div className="col-span-3">
        <div className="space-y-8">
          <div>
            <h2 className="text-[3rem] font-[700] tracking-[-0.05em] text-[#E8D1FF] leading-none">Games Played</h2>
            <div className="mt-4 space-y-2">
              <div className="flex justify-between">
                <span className="text-[2.1rem] font-[200] tracking-[-0.05em] text-[#292B2D]">Total</span>
                <span className="text-[2.1rem] font-[700] tracking-[-0.05em] text-[#E8D1FF]">
                  <CountUp end={stats.gamesPlayed.total} />
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-[2.1rem] font-[200] tracking-[-0.05em] text-[#292B2D]">Won</span>
                <span className="text-[2.1rem] font-[700] tracking-[-0.05em] text-[#E8D1FF]">
                  <CountUp end={stats.gamesPlayed.won} delay={200} />
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-[2.1rem] font-[200] tracking-[-0.05em] text-[#292B2D]">Lost</span>
                <span className="text-[2.1rem] font-[700] tracking-[-0.05em] text-[#E8D1FF]">
                  <CountUp end={stats.gamesPlayed.lost} delay={400} />
                </span>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-[3rem] font-[700] tracking-[-0.05em] text-[#E8D1FF] leading-none">Questions Answered</h2>
            <div className="mt-4 space-y-2">
              <div className="flex justify-between">
                <span className="text-[2.1rem] font-[200] tracking-[-0.05em] text-[#292B2D]">Correct</span>
                <span className="text-[2.1rem] font-[700] tracking-[-0.05em] text-[#E8D1FF]">
                  <CountUp end={stats.questions.correct} />
                </span>
              </div>
              <div className="flex justify-between">
                <span className="text-[2.1rem] font-[200] tracking-[-0.05em] text-[#292B2D]">Incorrect</span>
                <span className="text-[2.1rem] font-[700] tracking-[-0.05em] text-[#E8D1FF]">
                  <CountUp end={stats.questions.incorrect} delay={200} />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="col-span-4">
        <h2 className="text-[3rem] font-[700] tracking-[-0.05em] text-[#E8D1FF] leading-none mb-8">Your Learning Progress</h2>
        <ProgressGraph 
          data={progressData}
          color="#E8D1FF"
          labelColor="#292B2D"
          months={months}
        />
      </div>

      <div className="col-span-3">
        <div className="space-y-8">
          <div>
            <h2 className="text-[6rem] font-[200] tracking-[-0.05em] text-[#E8D1FF] leading-none">Get Even<br />Better!!</h2>
            <div className="mt-8 space-y-4">
              <div>
                <div className="text-[2.1rem] text-[#292B2D]">You have improved the most in</div>
                <div className="text-[2.1rem] font-[700] tracking-[-0.05em] text-[#E8D1FF]">Road Safety</div>
              </div>
              <div>
                <div className="text-[2.1rem] text-[#292B2D]">Focus on</div>
                <div className="text-[2.1rem] font-[700] tracking-[-0.05em] text-[#E8D1FF]">Home Safety</div>
              </div>
              <div>
                <div className="text-[2.1rem] text-[#292B2D]">Play this game next</div>
                <div className="text-[2.1rem] font-[700] tracking-[-0.05em] text-[#E8D1FF]">Safety Explorer</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};